import { TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import { editDeeplink } from 'src/store/modules/imageUpload';

interface editTextProps {
  menuTitle: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '20px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #E5E8EB',
    borderRadius: '8px'
  },
  fontBox: {
    width: '100%',
    height: '44px',
    padding: '0 12px',
    cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    color: '#191F28',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA'
  },
  input: {
    width: '100%',
    height: '100px',
    padding: '12px',
    outline: 'none',
    overflow: 'auto',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA',
    color: '#191F28',
    '&:focus': {
      borderColor: '#191F28',
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#191F28'
  },

  bottomBtn: {
    padding: '8px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA'
  },
  btnMinusPlus: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E8EB'
  },

  fontNumber: {
    width: '48px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#191F28',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E8EB'
  },

  buttonWrapper: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    borderRadius: '6px'
  },
  buttonImage: {
    maxWidth: '24px',
    minWidth: '24px',
    maxHeight: '24px',
    minHeight: '24px'
  },

  boxWrapper: {
    margin: '0 8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  colorBox: {
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: '#F2F3F5',
    textAlign: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '6px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  }
}));

const EditDeeplink: FC<editTextProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const handleText = e => {
    const textSplit = e.target.value.split('');
    if (
      textSplit[textSplit.length - 1] === '\\' ||
      textSplit[textSplit.length - 1] === '\n'
    )
      return;

    const newDeeplinks = e.target.value.replace(/"/g, "'");
    const newDeeplink = { [type]: newDeeplinks };
    dispatch(editDeeplink({ ...deeplink, ...newDeeplink }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '13px',
          fontWeight: 600,
          fontFamily: "'Poppins', sans-serif",
          color: '#191F28',
          letterSpacing: '0.02em'
        }}
      >
        {menuTitle === 'BACKGROUND' ? 'DEEPLINK' : `${menuTitle} DEEPLINK`}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          height: '100px'
        }}
      >
        {/* <div className={classes.container}> */}
        <TextField
          className={classes.input}
          id="standard-multiline-flexible"
          multiline
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputText
            },
            disableUnderline: true
          }}
          value={deeplink[type]}
          onChange={handleText}
          // onKeyPress={handleKey}
        />
        {/* </div> */}
      </div>
    </div>
  );
};

export default EditDeeplink;
